import { Component, OnInit } from '@angular/core';
import { SharedConst } from 'src/app/core/constants/shared.constant';
import { StorageConditionDto } from '../../models/storagecondition/storagecondition.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageCondtionService } from '../../services/storagecondition.service';
import { StorageConditionConst } from 'src/app/core/constants/storagecondition.const';
import { GridComponent } from '@progress/kendo-angular-grid';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { DialogUploadComponent } from 'src/app/core/components/dialog-upload/dialog-upload.component';
import { RoleConstant } from 'src/app/core/constants/role.constants';

@Component({
    selector: 'app-storagecondition',
    templateUrl: './storagecondition.component.html',
    styleUrls: ['./storagecondition.component.scss'],
    standalone: false
})
export class StorageconditionComponent implements OnInit {
  globalGridData: StorageConditionDto[] = [];
  searchText: string = SharedConst.empty;
  gridData: StorageConditionDto[] = [];
  isActive = false;
  constructor(private storageCondtionService: StorageCondtionService, public router: Router,
    private route: ActivatedRoute, public commonService: CommonService, private dialogService: DialogService) {
  }

  ngOnInit() {
    if (this.commonService.getUserRoleName() !== RoleConstant.ESAR_Admin) {
      this.router.navigate(['../../sar'], { relativeTo: this.route });
      return false;
    }
    this.getBuList();
  }

  getBuList() {
    this.storageCondtionService.getStorageConditionAll().subscribe((outputDtata: StorageConditionDto[]) => {
      this.gridData = outputDtata;
      this.globalGridData = Object.assign([], outputDtata);
      this.search();
    }
    );
  }

  search() {
    this.gridData = this.commonService.setupGobalSearch(this.globalGridData,
      this.isActive, StorageConditionConst.searchFieldName, this.searchText, StorageConditionConst.code)
  }

  clear() {
    this.searchText = SharedConst.empty;
    this.gridData = Object.assign([], this.globalGridData);
  }

  public exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }

  manage(isCreate: boolean, isActive: boolean, name: string, code: string, id: number) {
    this.router.navigate(["../" + StorageConditionConst.manageSCPath], {
      state: { isCreate: isCreate, id: id, name: name, code: code, isActive: isActive },
      relativeTo: this.route
    },
    );
  }

  public import(): void {
    const dialog: DialogRef = this.dialogService.open({
      content: DialogUploadComponent
    });

    dialog.result.subscribe((r: any) => {
      if (r.action === "Save") {
        let arr = JSON.parse(r.value).Sheet1 as Array<any>;
        let storageConditions: StorageConditionDto[] = arr.map((item: any) => {
          return {
            id: 0,
            name: item['Name'].toString(), code: item['Code'].toString(), isActive: item['Is Active'],
            createdBy: item['Created By'], modifiedBy: item['Modified By'],
            createdDateTime: undefined, modifiedDateTime: undefined
          };
        });
        this.storageCondtionService.importExcelData(storageConditions).subscribe((response: StorageConditionDto) => {
          this.commonService.showNotificationMessage(StorageConditionConst.bulkInsertMessage, 'success', 'right')
          this.getBuList();
        });
      }
    });
  }
}

